// English strings for the console batch 2 (BILLING-001 / PARTNER-001, owner 2026-10-25; D-067):
// subscriptions and invoices with the renewal rule, plan coupons, the referral programme and the
// revenue / shop reports, plus the shop's side (a coupon at checkout, invoices to print, "Refer a
// shop"). Spread into `en` as `en.billingOps`, so keys read `t("billingOps.…")`. Copy: DESIGN_SYSTEM §9.6.
export const billingOpsStrings = {
  nav: { subscriptions: "Subscriptions", promos: "Coupons & referrals" },
  sections: {
    subscriptions: "Every paid plan and trial, the invoices, and the renewal rule.",
    promos: "Plan coupons and the shop referral programme.",
  },
  subs: {
    lead: "Every paid plan and trial. Shops are reminded before a plan ends; a plan not renewed moves to Free.",
    tabs: { subs: "Subscriptions", invoices: "Invoices", rules: "Renewal rules" },
    filters: {
      all: "Running",
      renew_7d: "Ends in 7 days",
      short: "Wallet short",
      auto_off: "Auto-renew off",
      trial: "Trials",
      given: "Given free",
      ended: "Ended (30 days)",
    },
    columns: {
      shop: "Shop",
      plan: "Plan",
      price: "Price",
      ends: "Ends",
      renewal: "Renewal",
      reminders: "Reminders",
    },
    kinds: { paid: "Paid", trial: "Trial", given: "Given" },
    periods: { monthly: "Monthly", quarterly: "Every 3 months", yearly: "Yearly", none: "—" },
    mrr: "Monthly plan revenue",
    mrrHelp: "List prices of running paid plans, a month's worth (before coupons).",
    perMonth: "{amount}/month",
    daysLeft: { one: "{count} day left", other: "{count} days left" },
    endsToday: "Ends today",
    ended: "Ended {date}",
    autoOn: "Auto-renew on",
    autoOff: "Auto-renew off",
    short: "Wallet short",
    wallet: "Wallet {amount}",
    coupon: "Coupon {code} · {left} more",
    remind: "Remind now",
    reminded: "Reminder sent",
    noReminders: "None yet",
    reminderDay: { one: "{count} day", other: "{count} days" },
    reminderToday: "On the day",
    openShop: "Open shop",
    none: "No subscriptions here.",
    search: "Search shop or plan",
    count: { one: "{count} subscription", other: "{count} subscriptions" },
  },
  rules: {
    lead: "What happens when a paid plan comes to its end.",
    reminders: "Remind the shop before the plan ends",
    remindersHelp: "Days before the end. 1 = on the day. Up to 5.",
    addDay: "Add a day",
    removeDay: "Remove {day}",
    after: "When it ends and is not renewed",
    graceZero: "Move to the Free plan at once",
    graceDays: { one: "Move to Free after {count} day", other: "Move to Free after {count} days" },
    graceLabel: "Days before the move to Free",
    autoRenew:
      "Shops with auto-renew on are renewed from their Adyvance Wallet at the end; if the wallet is short they are told, and the rule above applies.",
    issuer: "Company details on invoices",
    issuerHelp:
      "Printed on every Adyvance invoice. Leave a field empty until you have it; nothing is made up.",
    fields: {
      legal_name: "Company name",
      pan_vat: "PAN / VAT number",
      address: "Address",
      phone: "Phone",
      email: "Email",
      note: "Line under the invoice",
    },
    save: "Save rules",
    saved: "Renewal rules saved",
    preview: "What shops are told",
    previewLine: "{when}: “Your plan ends {in}. Renew it, or your shop moves to the Free plan.”",
    today: "today",
    inDays: { one: "in {count} day", other: "in {count} days" },
  },
  invoices: {
    lead: "Every invoice Adyvance issued for plan payments.",
    allMonths: "All months",
    columns: {
      number: "Invoice",
      shop: "Shop",
      plan: "Plan",
      date: "Date",
      list: "Price",
      discount: "Discount",
      amount: "Paid",
    },
    totals: "{count} invoices · {paid} paid · {discount} in coupon discounts",
    export: "Export CSV",
    view: "View",
    none: "No invoices yet. They appear when shops pay for a plan from their wallet.",
  },
  doc: {
    title: "Invoice",
    number: "No. {number}",
    date: "Date",
    from: "From",
    billTo: "Billed to",
    pan: "PAN/VAT {pan}",
    noIssuer: "Adyvance's company details are not set yet.",
    item: "Item",
    amount: "Amount",
    total: "Total paid",
    paidVia: "Paid from the Adyvance Wallet",
    print: "Print",
    close: "Close",
  },
  coupons: {
    lead: "Codes shops type at checkout to pay less for a plan. Each shop can use a code once.",
    new: "New coupon",
    edit: "Edit coupon",
    code: "Code",
    codeHelp: "3 to 24 letters and digits, like DASHAIN20.",
    kind: "Discount",
    kinds: { percent: "Percent off", amount: "Amount off" },
    value: "How much",
    percentHelp: "Up to 90%. To give a plan free, use Give plan on the shop's page.",
    amountHelp: "In rupees, taken off each discounted payment.",
    plans: "Plans",
    anyPlan: "Every paid plan",
    periods: "Billing periods",
    anyPeriod: "Every period",
    payments: "Payments it discounts",
    paymentsHelp: "1 = the first payment only; 3 = the first payment and the next 2 renewals.",
    max: "Most shops that can use it",
    unlimited: "No limit",
    newOnly: "Only shops buying their first plan",
    starts: "Starts",
    ends: "Ends",
    noDate: "No date",
    active: "Shops can use it",
    note: "Note (only you see it)",
    save: "Save coupon",
    saved: "Coupon saved",
    none: "No coupons yet.",
    used: { one: "{count} shop used it", other: "{count} shops used it" },
    given: "{amount} off so far",
    off: "{value} off",
    forPayments: { one: "first payment", other: "{count} payments" },
    states: {
      active: "Active",
      off: "Off",
      ended: "Ended",
      scheduled: "Starts later",
      used_up: "Used up",
    },
    copy: "Copy code",
    copied: "Code copied",
    problems: {
      unknown: "That coupon code does not exist.",
      inactive: "That coupon is turned off.",
      not_started: "That coupon cannot be used yet.",
      ended: "That coupon has ended.",
      used_up: "That coupon has been used up.",
      already_used: "Your shop already used that coupon.",
      plan: "That coupon is not for this plan.",
      period: "That coupon is not for this billing period.",
      new_shops_only: "That coupon is for shops buying their first plan.",
    },
  },
  referrals: {
    lead: "Shops earn wallet credit when a shop they bring pays for a plan.",
    tabs: { coupons: "Coupons", referrals: "Referrals" },
    settings: "Programme",
    enabled: "Referral programme",
    enabledHelp:
      "Shops see their code under Adyvance Wallet → Refer a shop. Turning it off stops new rewards.",
    percent: "Reward: % of each plan payment",
    months: "For how many months after the first payment",
    save: "Save",
    saved: "Referral programme saved",
    how: "A shop shares its code. A new shop types it when signing up. On every plan payment in the next {months} months, the first shop gets {percent}% as Adyvance Wallet credit.",
    totals: {
      referrals: "Shops brought",
      earning: "Still earning",
      earned: "Credit given",
      month: "This month",
    },
    columns: {
      referrer: "Brought by",
      shop: "Shop",
      since: "First payment",
      until: "Earning until",
      earned: "Earned",
    },
    top: "Top referrers",
    waiting: "Signed up with a code, no plan bought yet",
    void: "Stop rewards",
    voided: "Rewards stopped",
    stopped: "Stopped",
    none: "No referrals yet.",
  },
  analytics: {
    tabs: { revenue: "Revenue", shops: "Shops" },
    privacy: "Totals only: no shop's customers are shown.",
    mrr: "Monthly plan revenue",
    arr: "A year at this rate",
    arpu: "Per paying shop",
    paying: "Paying shops",
    churned: "Stopped paying this month",
    newPaying: "Started paying this month",
    mrrTitle: "Monthly plan revenue, last 12 months",
    payingTitle: "Paying shops, last 12 months",
    earnedTitle: "What shops spent from their wallets, last 6 months",
    sources: {
      plans: "Plans",
      sms: "SMS",
      ai: "root AI",
      themes: "Themes",
      ads: "Ads",
      imports: "Imports",
      other: "Other",
    },
    discounts: "Coupon discounts this month",
    referral: "Referral rewards this month",
    plansTitle: "Plans",
    signupsTitle: "New shops, last 12 months",
    funnelTitle: "How far shops got",
    funnel: {
      signed_up: "Signed up",
      store_live: "Store live",
      products: "Added products",
      first_order: "Got an order",
      paying: "Paying",
    },
    cohortsTitle: "Shops by the month they joined",
    cohortCols: { month: "Joined", shops: "Shops", active: "Active now", paying: "Paying now" },
    activeTitle: "Shops signed in",
    d1: "Today",
    d7: "This week",
    d30: "This month",
    ordersTitle: "Orders on every shop, last 12 months",
    adoptionTitle: "What shops use",
    adoption: {
      verified: "Business verified",
      domain: "Own domain",
      channels: "Sampark or Daraz",
      wallet: "Topped up the wallet",
      paying: "On a paid plan",
    },
    series: { mrr: "Plan revenue (Rs)", paying: "Paying shops", shops: "Shops", orders: "Orders" },
  },
  shop: {
    coupon: "Coupon code",
    couponPh: "Have a code?",
    apply: "Apply",
    applied: "{code}: {off} off",
    appliedFor: { one: "for this payment", other: "for {count} payments" },
    remove: "Remove",
    listPrice: "Price",
    discount: "Coupon",
    total: "You pay",
    invoiceView: "View",
    referral: {
      title: "Refer a shop",
      lead: "Share your code. When a shop that signs up with it pays for a plan, you get {percent}% of each payment as wallet credit for {months} months.",
      off: "The referral programme is not open yet.",
      code: "Your code",
      copy: "Copy",
      copied: "Copied",
      link: "Sign-up link",
      earned: "Earned so far",
      shops: "Shops you brought",
      none: "No shops yet. Share your code on Facebook or with other sellers.",
      until: "Earning until {date}",
      ended: "Finished",
    },
  },
} as const;
